var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Sidekiq 管理画面")]),_c('h6',[_vm._v("開発ローカル環境で使っている auth0 のアカウントでログイン出来ます。")]),_c('CDataTable',{attrs:{"hover":"","bordered":"","fixed":"","items":_vm.links,"fields":_vm.linkFields},scopedSlots:_vm._u([{key:"link",fn:function(ref){
var app = ref.item;
return [_c('td',[_c('CLink',{attrs:{"href":app.link,"target":"_blank"}},[_vm._v(_vm._s(app.link))])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }